<template>
  <div class="toolPage">
    <div class="tool_item flex-rowc" @click="handleScreen">
      <i class="iconfont icon-liebiaofenlei"></i>
    </div>
    <div class="tool_item flex-rowc" @click="handleTop">
      <i class="iconfont icon-toTop"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "tool",
  data() {
    return {};
  },
  methods: {
    handleScreen() {},
    handleTop() {
        window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang='less' scoped>
.toolPage {
  position: fixed;
  bottom: 250px;
  right: 30px;
  .tool_item {
    width: 110px;
    height: 110px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 50%;
    box-shadow: 0 0 13px 10px rgba(0, 0, 0, 0.07);
    margin-bottom: 35px;
  }
  .iconfont {
    color: #515151;
    font-weight: 400;
  }
  .icon-liebiaofenlei {
    font-size: 42px;
  }
  .icon-toTop {
    font-size: 36px;
  }
}
</style>